import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=0a0357ba&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"
import style0 from "./monitor.vue?vue&type=style&index=0&id=0a0357ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0357ba",
  null
  
)

export default component.exports